module.exports = __webpack_public_path__ + "static/media/IMG_3142a.4970cf0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/IMG_3142a.jpg
// module id = 152
// module chunks = 0